export const themeList = [
  {
    id: "obsidian-minimal",
    name: "Obsidian Minimal",
    tagline: "Functional minimalism, near-black canvas",
    fonts: "Bricolage Grotesque + Inter",
    swatches: ["#0a0a0c", "#818cf8", "#f4f4f6"],
  },
  {
    id: "neon-terminal",
    name: "Neon Terminal",
    tagline: "Hacker-console, monospace everywhere",
    fonts: "JetBrains Mono + IBM Plex Mono",
    swatches: ["#000000", "#22e07a", "#6ee7a0"],
  },
  {
    id: "liquid-glass",
    name: "Liquid Glass",
    tagline: "Frosted cards over floating gradient orbs",
    fonts: "Space Grotesk + Inter",
    swatches: ["#0d0e1a", "#a78bfa", "#f472b6"],
  },
  {
    id: "bento-lab",
    name: "Bento Lab",
    tagline: "Apple-style bento grid, squircle cards",
    fonts: "Geist + Geist Mono",
    swatches: ["#101113", "#6ee7b7", "#eef1ee"],
  },
  {
    id: "brutalist-mono",
    name: "Brutalist Mono",
    tagline: "Thick borders, hard offset shadows",
    fonts: "Space Mono",
    swatches: ["#000000", "#eaff00", "#ffffff"],
  },
  {
    id: "aurora-gradient",
    name: "Aurora Gradient",
    tagline: "Moody drifting gradient mesh backdrop",
    fonts: "Bricolage Grotesque + Inter",
    swatches: ["#0b0a14", "#2dd4bf", "#a855f7"],
  },
  {
    id: "cyber-lavender",
    name: "Cyber Lavender",
    tagline: "Retro-futurist neon glow on a grid",
    fonts: "Sora + Inter",
    swatches: ["#0f0a1a", "#c084fc", "#f472b6"],
  },
  {
    id: "editorial-mono",
    name: "Editorial Mono",
    tagline: "Typography-driven, magazine-style layout",
    fonts: "Fraunces + Inter",
    swatches: ["#121212", "#d4a574", "#f2ede4"],
  },
  {
    id: "graphite-pro",
    name: "Graphite Pro",
    tagline: "Clean corporate-tech, quiet confidence",
    fonts: "Geist + Inter",
    swatches: ["#15171a", "#5b9dfb", "#f5f6f7"],
  },
  {
    id: "deep-space-retro",
    name: "Deep Space Retro",
    tagline: "Warm CRT glow, analog-inspired texture",
    fonts: "Space Mono + IBM Plex Mono",
    swatches: ["#0c0a08", "#f97316", "#f5e6d3"],
  },
];

export const DEFAULT_THEME = "obsidian-minimal";
export const STORAGE_KEY = "portfolio-theme";
export const THEME_EVENT = "portfolio-theme-change";
export const MODE_STORAGE_KEY = "portfolio-mode";
